import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhCN from './langs/zh_cn'
import zhTW from './langs/zh_tw'
import enUS from './langs/en'

Vue.use(VueI18n)

const messages = {
  'zh_cn': {
    ...zhLocale,
    ...zhCN
  },
  'zh_tw': {
    ...zhLocale,
    ...zhTW
  },
  'en': {
    ...enLocale,
    ...enUS
  }
}

// 智能检测默认语言
function getDefaultLanguage() {
  // 1. 检查localStorage中的语言设置
  const savedLanguage = localStorage.getItem('language')
  if (savedLanguage && ['zh_cn', 'zh_tw', 'en'].includes(savedLanguage)) {
    return savedLanguage
  }
  
  // 2. 检查浏览器语言设置
  const browserLang = navigator.language || navigator.userLanguage
  if (browserLang) {
    if (browserLang.startsWith('zh-CN') || browserLang === 'zh') {
      return 'zh_cn'
    } else if (browserLang.startsWith('zh-TW') || browserLang.startsWith('zh-HK') || browserLang.startsWith('zh-Hant')) {
      return 'zh_tw'
    } else if (browserLang.startsWith('en')) {
      return 'en'
    }
  }
  
  // 3. 默认返回简体中文
  return 'zh_tw'
}

const defaultLanguage = getDefaultLanguage()

const i18n = new VueI18n({
  locale: defaultLanguage,
  fallbackLocale: 'zh_cn',
  messages,
  silentTranslationWarn: true
})

// 设置 element-ui 语言
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n